// src/features/Auth/useAuthReady.js
// Pass-through hook: rely on AuthProvider to hydrate once and expose authReady.
// This avoids duplicate /accounts/me calls.

import { useAuth } from "../../AuthUser";

export default function useAuthReady() {
  const { authReady } = useAuth() || {};
  return !!authReady;
}
